<template>
  <div
    ref="vesselContainerListItem"
    class="
      vessel-container-list-item
      vs-con-loading__container
      clickable-cell-container
      w-full
    "
    @click="goToVesselContainerDetails(enterpriseVessel)"
  >
    <div
      class="list-item cell"
      :class="'cell-' + columnDefs[0].key"
      :style="'width:' + columnDefs[0].width + 'px'"
    >
      {{ enerpriseVesselName }}
    </div>

    <div
      class="list-item cell"
      :class="'cell-' + columnDefs[1].key"
      :style="'width:' + columnDefs[1].width + 'px'"
    >
      <!-- コンテナ集計情報 -->
      <container-status-count-list-view
        ref="ContainerStatusCountListView"
        :counts="counts"
      />
    </div>

    <div
      class="list-item cell ml-auto"
      :class="'cell-' + columnDefs[2].key"
      :style="'width:' + columnDefs[2].width + 'px'"
    >
      {{ lastUpdatedAt }}
    </div>
  </div>
</template>

<script>
import ContainerStatusCountListView from "./components/ContainerStatusCountListView.vue";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions, } = createNamespacedHelpers("ecoShip");
import moment from "moment-timezone";


export default {
  name: "VesselContainerListItem",
  components: {
    ContainerStatusCountListView,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    enterpriseVessel: { type: Object },
    size: { type: String, default: 'medium' },
    columnDefs: { type: Array, default: () => [] },
  },
  data() {
    return {
      isLoading: true,
      routerViewWidth: 1366,
      vesselContainers: null,
    }
  },
  watch: {
    onChangeWindowSize() {
      const routerViewElement = document.getElementsByClassName("router-view");
      if ( routerViewElement ){
        this.routerViewWidth = routerViewElement[0].getBoundingClientRect().width;
      } else {
        this.routerViewWidth = document.documentElement.clientWidth - 260;
      }
    },
  },
  computed: {
    ...mapState({
      hanasysExpert: state => state.hanasysExpert,
      hanasysExpertLastUpdatedAt: state => state.hanasysExpertLastUpdatedAt,
    }),
    counts() {
      const counts = {
        container_count: 0,
        active_count: 0,
        alert_count: 0,
        interlock_count: 0,
        power_off_count: 0,
      };

      // コンテナ数
      counts.container_count = this.enterprise_vessel_containers.length;
      this.channels
        .filter((channel) => channel.category3_id === null)
        .map((channel) => channel.channel_id)
        .forEach((channel_id) => {
          const channel = this.hanasysExpert[channel_id]; // firestoreのデータ

        if ( channel && channel.properties ) {
          const properties = JSON.parse(channel.properties);
          if (properties.tag_status === "I") {
            if ( channel.vs === "NO-VOLT" ) {
              counts.power_off_count++;
            } else {
              counts.interlock_count++;
            }
          } else if (properties.tag_status === "A") {
            counts.alert_count++;
          } else if (channel.vs === 'RUN'){
            counts.active_count++;
          } else {
            counts.power_off_count++;
          }
        }
      });
      return counts;
    },
    lastUpdatedAt() {
      // 最終更新日時
      if (this.channels.length === 0) return null;
      if (this.hanasysExpert.length === 0) return null;
      const lastTimestamp = this.channels
        .filter((channel) => channel.category3_id === null)
        .map((channel) => this.hanasysExpert[channel.channel_id])
        .filter((cd) => cd && cd.timestamp)
        .reduce((prev, cd, index) => {
          if (index === 0) return cd.timestamp;
          prev < cd.timestamp ? cd.timestamp : prev;
        }, null);
      return lastTimestamp === null
        ? null
        : moment(this.hanasysExpertLastUpdatedAt * 1000)
            .local()
            .format("YYYY/MM/DD HH:mm");
    },
    channels() {
      if (!this.vesselContainers) return [];
      return this.vesselContainers.channels;
    },
    enterprise_vessel_containers() {
      if (!this.vesselContainers) return [];
      return this.vesselContainers.enterprise_vessel_containers; // コンテナカードリストとして一覧表示. （軸）
    },
    enerpriseVesselName() {
      if(!this.enterpriseVessel) return "";
      const {name_ja, name} = this.enterpriseVessel;
      return name_ja || name || "";
    },
  },
  methods: {
    ...mapActions(["unsubscribeFirestore", "getVesselContainers"]),

    goToVesselContainerDetails(enterpriseVessel) {
      this.$router.push({
        name: "addon-eco-ship-vessel-container-details",
        query: {
          id: enterpriseVessel.enterprise_vessel_id,
        },
      });
    },

  },
  created() {},
  async mounted() {

    let routerViewElement = document.getElementsByClassName("router-view")
    routerViewElement[0].style.padding = "2.2rem"

    this.isLoading = true;
    this.$vs.loading({ container: this.$refs.vesselContainerListItem });

    this.vesselContainers = await this.getVesselContainers(
      this.enterpriseVessel,
    );

    this.$nextTick(() => {
      this.$vs.loading.close(this.$refs.vesselContainerListItem);
      this.isLoading = false;
    });
  },
  beforeDestroy() {
    this.unsubscribeFirestore();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.vessel-container-list-item {
  .row {
    min-height: 49px;
    height: fit-content;
    display: flex;
    border-bottom: solid 1px $aisea-light-white;
  }
  .clickable-cell-container {
    display: flex;
    transition: 0.3s;
    cursor: pointer;
    &:hover {
      background: $aisea-white;
    }
  }
  .cell {
    display: flex;
    margin-right: 20px;
    padding: 5px 10px;
    align-items: center;
    &.cell-vesselName {
      overflow-wrap: anywhere;
    }
    &.cell-select {
      width: 30px;
      .check-disabled {
        input {
          cursor: default;
        }
      }
    }
  }
}
</style>